const isDevelopment = false;

export const DOMAIN = isDevelopment
  ? "http://192.168.100.19:7021/api"
  : "https://wallet.cosmediccenter.co/api";
